<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import {authStore} from "#imports";
import {loadingStore} from "~/stores/loadingStore";
import PaymentSidebar from "~/components/payments/paymentSidebar.vue";
import SHA1 from "crypto-js/sha1"
import CryptoJS from "crypto-js"
const config = useRuntimeConfig()
const {$api, $toast} = useNuxtApp()
const router = useRouter()
const userStore = authStore()
const loading = loadingStore()
const {setLoading} = loading
const wallets = ref([])
const paymentMethod = ref('epoint')
const amount = ref('')
const isLoading = ref(false)
const {user} = userStore
definePageMeta({
  middleware: 'auth'
})
if (user?.level !== 'normal') {
   router.push('/payments')
}
const submitPayment = () => {
  if (!amount.value || isNaN(Number(amount.value)) || Number(amount.value) <= 0) {
    $toast.error('Zəhmət olmasa düzgün məbləğ daxil edin')
    return
  }
  const paymentData = paymentMethod.value === 'epoint'? 'epoint' : 'wallet';
  setLoading(true)
  isLoading.value = true
  $api.post('user/payment/balance', { amount: amount.value, payment_method: paymentData, wallet_id: paymentMethod.value }, userStore.headers)
    .then(res => {
      if (res.data) {
        // Redirect to the URL returned from the API
        window.location.href = res.data
      } else {
        $toast.success('Ödəniş tələbi göndərildi')
        router.push('/user/dashboard/payments')
      }
    })
    .catch(error => {
      $toast.error(error.response?.data?.message || 'Ödəniş zamanı xəta baş verdi')
    })
    .finally(() => {
      setLoading(false)
      isLoading.value = false
    })
}

const fetchWallets = async () => {
  try {
    // Əmin olun ki, config dəyərləri mövcuddur
    if (!config.public.key || !config.public.pub) {
      console.error('API konfiqurasiya dəyərləri tapılmadı');
      return;
    }

    const url = 'https://epoint.az/api/1/wallet/status';
    const signatureString = `${config.public.key}${config.public.pub}${config.public.key}`;
    const hash = SHA1(signatureString);

    // Browser və server mühitində işləyəcək şəkildə encode etmək
    const data = {
      public_key: config.public.pub,
    };

    // Browser-specific funksiyaları yoxlayın
    let encodedData, encodedSignature;

    if (typeof window !== 'undefined') {
      // Browser mühitində
      encodedData = btoa(JSON.stringify(data));
      encodedSignature = btoa(hash.toString(CryptoJS.enc.Latin1));
    } else {
      // Server mühitində
      encodedData = Buffer.from(JSON.stringify(data)).toString('base64');
      encodedSignature = Buffer.from(hash.toString(CryptoJS.enc.Latin1)).toString('base64');
    }

    const body = {
      data: encodedData,
      signature: encodedSignature
    };

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`API xətası: ${response.status}`);
    }

    const result = await response.json();
    console.log('Wallet məlumatları:', result);
    wallets.value = result;
  } catch (error) {
    console.error('Wallet məlumatlarını əldə edərkən xəta baş verdi:', error);
    $toast.error('Wallet məlumatlarını əldə edərkən xəta baş verdi');
  }
};

// Səhifə yüklənərkən wallet məlumatlarını əldə et
onMounted(async () => {
  await fetchWallets();
  console.log(paymentMethod.value)
});
</script>

<template>
  <main>
    <!-- Mobile and PC title -->
    <div class="container back-orange set-size">
      <div class="row">
        <div class="col-md-12">
          <div class="main-title">
            <h5> Balans artır </h5>
            <div class="single-sub-menu">
              <i class="fal fa-angle-down"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- PC and Mobile sub title -->
    <div class="container">
      <div class="row reset-margin">

        <!-- PC sub menus -->
        <div class="col-lg-3">
          <payment-sidebar />
        </div>

        <!-- Mobile and PC menu and payments -->
        <div class="col-lg-9">
          <div class="right-part">
            <div class="row hide-show">


              <!-- Payment form section -->
              <div class="col-md-12">
                <div class="online-payment-wrapper">
                  <div class="payment-card">
                    <div class="payment-header">
                      <div class="payment-logo">
                        <i class="fas fa-wallet"></i>
                      </div>
                      <h4>Balans artırma</h4>
                      <p>Ödəmələr 7/24 avtomatik olaraq həyata keçirilir.</p>
                    </div>

                    <form @submit.prevent="submitPayment" class="payment-form">
                      <div class="form-group">
                        <label for="amount">Məbləğ</label>
                        <div class="input-group">
                          <div class="input-icon">
                            <i class="fas fa-money-bill-wave"></i>
                          </div>
                          <input
                            id="amount"
                            v-model="amount"
                            type="number"
                            class="form-control"
                            placeholder="Məbləği daxil edin"
                            min="1"
                            required
                          />
                          <div class="input-suffix">
                            <span>AZN</span>
                          </div>
                        </div>
                      </div>
                      <div class="payment-methods-selection">
                        <h6>Ödəniş üsulunu seçin</h6>
                        <div class="payment-methods-list">
                          <div class="payment-method-item" :class="{ 'active': paymentMethod === 'epoint' }">
                            <input v-model="paymentMethod" type="radio" id="method-card" value="epoint" name="method">
                            <label for="method-card">
                              <div class="method-icon">
                                <i class="fas fa-credit-card"></i>
                              </div>
                              <div class="method-info">
                                <span class="method-name">Kart ilə</span>
                                <span class="method-description">Visa, MasterCard, Maestro</span>
                              </div>
                            </label>
                          </div>

                          <div v-for="(wallet, key) in wallets"
                               :key="key"
                               class="payment-method-item"
                               :class="{ 'active': paymentMethod === key }">
                            <input v-model="paymentMethod" type="radio" :id="`method-${key}`" :value="key" name="method">
                            <label :for="`method-${key}`">
                              <div class="method-icon">
                                <i class="fas fa-wallet"></i>
                              </div>
                              <div class="method-info">
                                <span class="method-name">{{wallet}} ilə</span>
                                <span class="method-description">Elektron pul kisəsi</span>
                              </div>
                            </label>
                          </div>
                        </div>
                      </div>
                      <button
                        type="submit"
                        class="btn-payment"
                        :disabled="isLoading"
                      >
                        <span v-if="!isLoading">
                          <i class="fas fa-lock mr-2"></i> Təhlükəsiz ödəniş et
                        </span>
                        <span v-else>
                          <i class="fas fa-spinner fa-spin"></i> Gözləyin...
                        </span>
                      </button>
                    </form>

                    <div class="payment-methods">
                      <p>Qəbul edilən ödəniş üsulları:</p>
                      <div class="payment-icons">
                        <i class="fab fa-cc-visa"></i>
                        <i class="fab fa-cc-mastercard"></i>
                        <i class="fab fa-cc-amex"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Payment instructions -->
              <div class="col-md-12">
                <div class="payment-instructions">
                  <h5><i class="fas fa-info-circle"></i> Ödəniş təlimatları</h5>
                  <ol>
                    <li>Yuxarıdakı formada artırmaq istədiyiniz məbləği daxil edin</li>
                    <li>Təhlükəsiz ödəniş et düyməsinə klikləyin</li>
                    <li>Bank ödəniş səhifəsinə yönləndiriləcəksiniz</li>
                    <li>Kart məlumatlarınızı daxil edin və ödənişi təsdiqləyin</li>
                    <li>Ödəniş tamamlandıqdan sonra balansınız avtomatik artırılacaq</li>
                  </ol>
                  <div class="support-note">
                    <p>Hər hansı problem yaşayırsınızsa, <nuxt-link to="/pages/contact">dəstək komandamızla</nuxt-link> əlaqə saxlayın.</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>

  </main>
</template>

<style scoped>
/* Payment features section */
.payment-features {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 30px;
}

.feature-item {
  flex: 1;
  min-width: 200px;
  background: linear-gradient(145deg, #ffffff, #f5f5f5);
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.feature-icon {
  background: #f9a533;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  box-shadow: 0 4px 10px rgba(249, 165, 51, 0.2);
}

.feature-icon i {
  color: white;
  font-size: 1.2rem;
}

.feature-text h5 {
  margin: 0 0 5px 0;
  font-weight: 600;
  color: #333;
}

.feature-text p {
  margin: 0;
  font-size: 0.9rem;
  color: #666;
}

/* Payment form styling */
.online-payment-wrapper {
  background: #fff;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  padding: 0;
  margin-bottom: 30px;
  overflow: hidden;
  border: 1px solid #eaeaea;
}

.payment-card {
  width: 100%;
}

.payment-header {
  background: #f9a533;
  color: white;
  padding: 30px;
  text-align: center;
  position: relative;
}

.payment-logo {
  width: 70px;
  height: 70px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.payment-logo i {
  font-size: 2rem;
  color: #f9a533;
}

.payment-header h4 {
  font-size: 1.8rem;
  margin-bottom: 10px;
  font-weight: 700;
}

.payment-header p {
  opacity: 0.9;
  margin: 0;
}

.payment-form {
  padding: 20px;
  background: #f9f9f9;
  border-top: 1px solid #eaeaea;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  font-weight: 600;
  color: #555;
  margin-bottom: 8px;
  transition: all 0.3s ease;
  font-size: 1rem;
}

.form-group:focus-within label {
  color: #f9a533;
  transform: translateY(-2px);
}

.input-group {
  display: flex;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.input-group:focus-within {
  box-shadow: 0 4px 15px rgba(249, 165, 51, 0.15);
}

.input-group:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.input-group:hover .input-icon,
.input-group:hover .input-suffix {
  background-color: #f0f0f0;
}

.input-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-right: none;
  padding: 0 15px;
  border-radius: 8px 0 0 8px;
  color: #f9a533;
}

.input-icon i {
  font-size: 1.2rem;
}

.form-control {
  flex: 1;
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid #ddd;
  border-left: none;
  border-right: none;
  border-radius: 0;
  font-size: 1.1rem;
  font-weight: 500;
  color: #333;
  transition: all 0.3s ease;
}

.form-control::placeholder {
  color: #aaa;
  font-weight: 400;
}

.form-control:focus {
  outline: none;
  border-color: #f9a533;
}

.input-suffix {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-left: none;
  padding: 0 15px;
  border-radius: 0 8px 8px 0;
  font-weight: 600;
  color: #555;
  min-width: 60px;
}

/* Remove spinner buttons from number input */
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

.btn-payment {
  background: #f9a533;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;
}

.btn-payment:hover:not(:disabled) {
  background: #e89121;
  box-shadow: 0 4px 8px rgba(249, 165, 51, 0.3);
}

.btn-payment:disabled {
  background: #cccccc;
  cursor: not-allowed;
}

.payment-methods {
  padding: 20px;
  background: #f9f9f9;
  border-top: 1px solid #eaeaea;
}

.payment-methods p {
  margin-bottom: 10px;
  font-weight: 600;
  color: #333;
}

.payment-icons {
  display: flex;
  gap: 10px;
}

.payment-icons i {
  font-size: 1.5rem;
  color: #f9a533;
}

.payment-instructions {
  padding: 20px;
  background: #f9f9f9;
  border-top: 1px solid #eaeaea;
}

.payment-instructions h5 {
  margin-bottom: 15px;
  font-weight: 600;
  color: #333;
}

.payment-instructions ol {
  list-style-type: decimal;
  padding-left: 20px;
  margin-bottom: 15px;
}

.payment-instructions ol li {
  margin-bottom: 5px;
  color: #666;
}

.support-note {
  text-align: center;
  color: #666;
  font-size: 0.9rem;
}

.support-note a {
  color: #f9a533;
  text-decoration: none;
}

.support-note a:hover {
  text-decoration: underline;
}

/* Ensure this matches the existing site styles */
.selected-link {
  color: #f9a533 !important;
  font-weight: 600;
}

.left-nav ul li a {
  display: block;
  padding: 10px 15px;
  color: #333;
  text-decoration: none;
  transition: all 0.3s;
}

.left-nav ul li a i {
  margin-right: 10px;
}

.left-nav ul li a:hover {
  background-color: #f8f9fa;
}

/* Mobile responsive styles */
@media (max-width: 992px) {
  .payment-features {
    flex-direction: column;
  }

  .feature-item {
    min-width: 100%;
  }

  .payment-header {
    padding: 20px;
  }

  .payment-logo {
    width: 60px;
    height: 60px;
  }

  .payment-header h4 {
    font-size: 1.5rem;
  }
}

@media (max-width: 576px) {
  .payment-instructions ol {
    padding-left: 15px;
  }

  .payment-icons i {
    font-size: 1.2rem;
  }

  .btn-payment {
    padding: 0.6rem 0.8rem;
  }

  .payment-logo {
    width: 50px;
    height: 50px;
    margin-bottom: 15px;
  }

  .payment-logo i {
    font-size: 1.5rem;
  }

  .feature-icon {
    width: 40px;
    height: 40px;
  }

  .feature-icon i {
    font-size: 1rem;
  }

  .feature-text h5 {
    font-size: 1rem;
  }

  .feature-text p {
    font-size: 0.8rem;
  }
}

/* Animation effects */
@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.btn-payment:not(:disabled):active {
  transform: scale(0.98);
}

.payment-logo {
  animation: pulse 2s infinite;
}

/* Focus styles for better accessibility */
.form-control:focus {
  border-color: #f9a533;
  box-shadow: 0 0 0 0.2rem rgba(249, 165, 51, 0.25);
  outline: none;
}

/* Custom scrollbar for the page */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #f9a533;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #e89121;
}

/* Payment methods selection styling */
.payment-methods-selection {
  margin-bottom: 20px;
}

.payment-methods-selection h6 {
  font-weight: 600;
  color: #555;
  margin-bottom: 12px;
  font-size: 1rem;
}

.payment-methods-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.payment-method-item {
  position: relative;
  background: #fff;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  transition: all 0.3s ease;
  overflow: hidden;
}

.payment-method-item:hover {
  border-color: #f9a533;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  transform: translateY(-2px);
}

.payment-method-item.active {
  border-color: #f9a533;
  background-color: rgba(249, 165, 51, 0.05);
  box-shadow: 0 4px 12px rgba(249, 165, 51, 0.15);
}

.payment-method-item input[type="radio"] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.payment-method-item label {
  display: flex;
  align-items: center;
  padding: 15px;
  cursor: pointer;
  width: 100%;
  margin: 0;
}

.method-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: #f9a533;
  border-radius: 50%;
  margin-right: 15px;
  color: white;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.payment-method-item:hover .method-icon {
  transform: scale(1.1);
}

.payment-method-item.active .method-icon {
  background: #f9a533;
  box-shadow: 0 0 0 4px rgba(249, 165, 51, 0.2);
}

.method-info {
  display: flex;
  flex-direction: column;
}

.method-name {
  font-weight: 600;
  color: #333;
  font-size: 1rem;
  margin-bottom: 3px;
}

.method-description {
  font-size: 0.85rem;
  color: #777;
}

.payment-method-item::after {
  content: '';
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  border: 2px solid #ddd;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.payment-method-item.active::after {
  border-color: #f9a533;
  background: #f9a533;
  box-shadow: inset 0 0 0 4px white;
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .payment-method-item label {
    padding: 12px;
  }

  .method-icon {
    width: 35px;
    height: 35px;
    margin-right: 10px;
  }

  .method-name {
    font-size: 0.95rem;
  }

  .method-description {
    font-size: 0.8rem;
  }
}

/* Animation for selection */
@keyframes selectPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(249, 165, 51, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(249, 165, 51, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(249, 165, 51, 0);
  }
}

.payment-method-item.active .method-icon {
  animation: selectPulse 1.5s infinite;
}
</style>